var PolygonGeneralGoModelToDataConverter = /** @class */ (function () {
    function PolygonGeneralGoModelToDataConverter(data) {
        this._stroke = data.stroke;
        this._strokeWidth = data.strokeWidth;
        this._lineType = data.lineType;
        this._fill = data.fill;
    }
    Object.defineProperty(PolygonGeneralGoModelToDataConverter.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralGoModelToDataConverter.prototype, "strokeWidth", {
        get: function () {
            return this._strokeWidth;
        },
        set: function (v) {
            this._strokeWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralGoModelToDataConverter.prototype, "lineType", {
        get: function () {
            return this._lineType;
        },
        set: function (v) {
            this._lineType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralGoModelToDataConverter.prototype, "fill", {
        get: function () {
            return this._fill;
        },
        set: function (v) {
            this._fill = v;
        },
        enumerable: true,
        configurable: true
    });
    return PolygonGeneralGoModelToDataConverter;
}());
export { PolygonGeneralGoModelToDataConverter };
